import { useTranslation } from "react-i18next";

export function TackLogo({
  size = "md",
  showSlogan = false,
  variant = "default",
}: {
  size?: "sm" | "md" | "lg" | "xl";
  showSlogan?: boolean;
  variant?: "default" | "inverted";
}) {
  const { t } = useTranslation();
  const sizeClasses = {
    sm: { text: "text-[11.5px]", badge: "size-8" },
    md: { text: "text-base", badge: "size-11" },
    lg: { text: "text-[23px]", badge: "size-16" },
    xl: { text: "text-[35px]", badge: "size-24" },
  };

  const s = sizeClasses[size];

  const colorClasses =
    variant === "inverted"
      ? "bg-primary-foreground text-primary ring-primary-foreground/30"
      : "bg-primary text-primary-foreground ring-primary/20";

  return (
    <div className="flex flex-col items-start">
      <span
        className={`inline-flex items-center justify-center rounded-full font-display font-bold tracking-tight leading-none ring-1 shadow-md ${colorClasses} ${s.badge} ${s.text}`}
      >
        <span>Tack.</span>
      </span>
      {showSlogan && (
        <span className="text-[10px] text-muted-foreground tracking-wide leading-none mt-1">
          {t("common.slogan")}
        </span>
      )}
    </div>
  );
}
